import 'magnific-popup';
import Cookies from 'js-cookie';

/**
 * Subscribe popup
 */

const $win = $(window);

$win.on('load', function() {
	if (Cookies.get('verdi-newsletter') === undefined ) {
		$.magnificPopup.open({
			items: {
				src: '#subscribe-popup'
			},
			type: 'inline',
			closeOnContentClick: true,
			modal: true,
			callbacks: {
				close() {
					Cookies.set('verdi-newsletter', 1)
				}
			}
		})
	}
})

/**
 * Close popup on subscribe
 */
 $('.popup-subscribe form').on(
  'formSubmitedSuccess',
  (e) => {
    $.magnificPopup.close();
    Cookies.set('verdi-newsletter', 1, { expires: 365 })
  }
);
